import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { ChatRoom } from "@/react/types/Chat/ChatRoom";
import type { SliceStateCreator } from "../../types";
import { initialChatRoomState, initialChatRoomUiState } from "./constants";
import type { ChatRoomActionsSliceState } from "./types";

export const createChatRoomActionsSlice: SliceStateCreator<
  ChatRoomActionsSliceState
> = (set, get) => ({
  actions: {
    createNewChatRoom: uuid => {
      set(state => {
        state.chatRoomStateMap.set(uuid, { ...initialChatRoomState });
      });
      return initialChatRoomUiState;
    },
    fetchChatRoom: async (uuid: string) => {
      const newChatRoomState = {
        ...initialChatRoomState,
        uiState: {
          ...initialChatRoomUiState,
          isLoading: true,
        },
      };
      set(state => {
        state.chatRoomStateMap.set(uuid, newChatRoomState);
      });
      try {
        const data = await reactQueryGet<{ chat_room: ChatRoom }>(
          internalApi.chatRooms.show({ uuid }),
        );
        if (data.chat_room) {
          set(state => {
            const chatRoom = data.chat_room;
            state.chatRoomMap.set(uuid, chatRoom);
            const chatRoomState = state.chatRoomStateMap.get(uuid);
            if (chatRoomState) {
              chatRoomState.uiState.isLoading = false;
            }
          });
        }
      } catch (error) {
        set(state => {
          const chatRoomState = state.chatRoomStateMap.get(uuid);
          if (chatRoomState) {
            chatRoomState.uiState.isLoading = false;
          }
        });
        console.error(error);
      }
    },
    ensureChatRoom: async (uuid: string) => {
      if (!get().chatRoomMap.get(uuid)) {
        await get().actions.fetchChatRoom(uuid);
      }
    },
    updateChatRoom: (chatRoom: ChatRoom) =>
      set(state => {
        const currentChatRoom = state.chatRoomMap.get(chatRoom.uuid);
        if (currentChatRoom) {
          state.chatRoomMap.set(chatRoom.uuid, {
            ...currentChatRoom,
            ...chatRoom,
          });
        }
      }),
    appendChatRoom: (chatRoom: ChatRoom) =>
      set(state => {
        state.chatRoomMap.delete(chatRoom.uuid);
        state.chatRoomMap.set(chatRoom.uuid, chatRoom);
      }),
    removeChatRoom: (uuid: string) =>
      set(state => {
        state.chatRoomMap.delete(uuid);
      }),
    markChatRoomAsRead: (uuid: string) =>
      set(state => {
        const chatRoom = state.chatRoomMap.get(uuid);
        if (chatRoom) {
          chatRoom.unread_messages_count = 0;
        }
      }),
  },
});
